import {
  ADD_BANKDEPOSIT,
  GET_ALLBANKDEPOSIT,
  LOADING_BANKDEPOSIT,
  STOP_LOADING_BANKDEPOSIT,
} from "../types";

const initialState = {
  bankDeposits: [],
  total: 0,
  loading_state: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_BANKDEPOSIT:
      // The list is refetched straight after a create, so the row order and
      // pagination stay whatever the server says — nothing to merge here.
      return state;

    case GET_ALLBANKDEPOSIT:
      return {
        ...state,
        bankDeposits: action.payload.data,
        total: action.payload.total,
      };

    case LOADING_BANKDEPOSIT:
      return {
        ...state,
        loading_state: true,
      };

    case STOP_LOADING_BANKDEPOSIT:
      return {
        ...state,
        loading_state: false,
      };

    default:
      return state;
  }
}
